import type { DealInsightsApi, DealInsightsCache, DealInsightsChartInputApi } from '@openx/types/dealInsights';
import { dealInsightsDefaultDataApi } from '../constants';
import { removeUnrelatedChartsFromParamsString } from './removeUnrelatedChartsFromParamsString';

export const extractDataAndLoadingStateFromCache = (param: {
  cache: DealInsightsCache;
  paramsString: string;
  activeChartKeys: (keyof DealInsightsChartInputApi)[];
}) => {
  const { cache, paramsString, activeChartKeys } = param;

  const chartsLoadingState: Partial<Record<keyof DealInsightsChartInputApi, boolean>> = {};

  const data: DealInsightsApi = activeChartKeys.reduce(
    (acc, chartKey) => {
      const paramsStringRelated = removeUnrelatedChartsFromParamsString(paramsString, chartKey);
      if (!cache[chartKey]?.[paramsStringRelated]?.data) {
        chartsLoadingState[chartKey] = true;
        return acc;
      }
      acc[chartKey as string] = cache[chartKey][paramsStringRelated].data;
      return acc;
    },
    //Need to spread dealInsightsDefaultDataApi object to make data imutable so that components are properly re-rendered on updates
    { ...dealInsightsDefaultDataApi }
  );

  const areAllChartsLoading = Object.keys(chartsLoadingState).length === activeChartKeys.length;

  return { data: areAllChartsLoading ? undefined : data, chartsLoadingState };
};
